@if (first(); as f) {
  @if (f.entity === 'campaign-measure') {
    <ces-measure-detail [detail]="f" />
  } @else if (f.entity === 'campaign-info') {
    <ces-auscultation-detail [details]="details()" />
  } @else if (f.entity === 'campaign') {
    <ces-campaign-detail [detail]="f" />
  } @else if (!isSpecialEntity(f.entity)) {
    <ces-generic-detail [detail]="f" />
  }
}
